import Vue from 'vue'
import NewsIcon from "./components/NewsIcon.vue";
import NewsList from "./components/NewsList.vue";
import InfoseekNews from "./components/InfoseekNews.vue";
import PopularEntryList from "./components/PopularEntryList.vue";
import ShareButtonTwitter from "./components/ShareButtonTwitter.vue";
import JumpButton from "./components/JumpButton.vue";
import HatenaCommentList from "./components/HatenaCommentList.vue";
import HatenaCommentListItem from "./components/HatenaCommentListItem.vue";


Vue.config.productionTip = false;

Vue.component("hatena-comment-list", HatenaCommentList);
Vue.component("hatena-comment-list-item", HatenaCommentListItem);
Vue.component("infoseek-news", InfoseekNews);
Vue.component("jump-button", JumpButton);
Vue.component("news-icon", NewsIcon);
Vue.component("news-list", NewsList);
Vue.component("popular-entry-list", PopularEntryList);
Vue.component("share-button-twitter", ShareButtonTwitter);

new Vue({}).$mount('#app');
